import UserCardContainer from "../../Componant/Users/UserCard";

const UserCard = () => {
  return (
    <div className="page-body">
      <UserCardContainer />
    </div>
  );
};

export default UserCard;
